module.exports = __webpack_public_path__ + "static/media/img-clock-large@3x.4597fd3d.png";